import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-175">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-176">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="bg-[#FAF6F0] rounded-3xl max-w-2xl w-full max-h-[85vh] flex flex-col shadow-2xl" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-177">
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-[#2B2A26]/10" data-id="element-178">
              <h2 id="modal-title" className="text-2xl md:text-3xl text-[#2B2A26]" style={{
            fontFamily: "'Fraunces', serif"
          }} data-id="element-179">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-[#2B2A26]/5 transition-colors" aria-label="Cerrar" data-id="element-180">
                <X className="w-5 h-5 text-[#2B2A26]" data-id="element-181" />
              </button>
            </div>
            <div className="overflow-y-auto px-6 md:px-8 py-6 text-[#2B2A26]/80 leading-relaxed space-y-4" data-id="element-182">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}